/**
 * Created by Asad on 12/30/2019.
 */
export default {
    computed: {
        user(){
            return this.$auth.user().id;
        }
    }
}